import React from 'react';
// import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {Translate} from 'views/module';

const Type = (props) => {
  return (
    <Typography
      sx={{
        fontWeight: 'bold',
      }}
    >
      <Translate
        expression='client.ClientDetail.CareviewSettings.Types.FiveStar.Title'
      />
    </Typography>
  );
};

Type.propTypes = {
};
export default React.memo(Type);
